module.exports = __webpack_public_path__ + "images/emoji/large_blue_diamond.cdcfa9597d57942a6c19.png";